import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 87A5BD64-6069-4C5B-8D50-69D9049B80BC
 * name peanut
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/peanut.svg
 * tags
 * - Food / Drink 
 * - Agriculture 
 */
export const PeanutIcon = createSvgIcon(<><path d="M16 12.77A2 2 0 0 1 15.86 10.12A5 5 0 0 0 13.04 2.12A5.74 5.74 0 0 0 12 2A5 5 0 0 0 7 7A5 5 0 0 0 8.11 10.12A2 2 0 0 1 8 12.72A5.5 5.5 0 0 0 10.81 21.87A5.42 5.42 0 0 0 12 22A5.5 5.5 0 0 0 16 12.77M13 5A1 1 0 1 1 12 6A1 1 0 0 1 13 5M11 18A1 1 0 1 1 12 17A1 1 0 0 1 11 18M12 15A1 1 0 1 1 13 16A1 1 0 0 1 12 15M14 19A1 1 0 1 1 15 18A1 1 0 0 1 14 19Z" /></>, 'PeanutIcon');
export default PeanutIcon